import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Translation } from 'react-i18next';
import _ from 'lodash';
import { Row, Col } from 'antd';
import utils from '../common/utils';
import '../scss/campaign.scss';

export default class Campaign extends Component {
  componentDidMount() {
    this.props.fetchAllCampaignAction({
      pos: 0,
      count: 10,
    });
  }

  render() {
    const campaigns = this.props.campaign || [];

    return (
      <Translation>
        {(t) => (
          <div className="campains">
            <div className="campains-container">
              <h3 className="campains-title">
                {t('navigation.campaign')}
              </h3>
              <div className="campain-contain">
                <Row>
                  {_.map([...campaigns], (value, index) => (

                    <Col span={8}>
                      <div className="campain-item">
                        <a href={`${value.link}`} rel="noreferrer" target="_blank" className="carousel__item-link">
                          <div className="campain-img">
                            <img
                              src={`${value.path}`}
                              alt="Anh"
                              className="slider-img"
                            />
                          </div>
                          <div className="campain-item-text">
                            <div className="campain-item-time">
                                    <span>{`${utils.formatTimeFromUnix(value.start_time)}`}</span>
                                    {' '}
                                    -<span>{`${utils.formatTimeFromUnix(value.end_time)}`}</span>
                                  </div>

                            <div className="campain-item-title">
                                    {window.localStorage.getItem('LANG') === 'vi' ? value.title.VI : value.title.EN}
                                  </div>
                          </div>
                        </a>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
